export default __webpack_public_path__ + "static/media/Sass.d2a6a057.png";